"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    menuDividerClassNames: function() {
        return menuDividerClassNames;
    },
    useMenuDividerStyles_unstable: function() {
        return useMenuDividerStyles_unstable;
    }
});
const _react = require("@griffel/react");
const menuDividerClassNames = {
    root: 'fui-MenuDivider'
};
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        jrapky: 0,
        Frg6f3: 0,
        t21cq0: 0,
        B6of3ja: 0,
        B74szlk: "f8dz51a",
        a9b677: "f14z66ap",
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        Bgfg5da: "f1facbz3"
    }
}, {
    d: [
        [
            ".f8dz51a{margin:4px -5px 4px -5px;}",
            {
                p: -1
            }
        ],
        ".f14z66ap{width:auto;}",
        [
            ".f1facbz3{border-bottom:var(--strokeWidthThin) solid var(--colorNeutralStroke2);}",
            {
                p: -1
            }
        ]
    ]
});
const useMenuDividerStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(menuDividerClassNames.root, styles.root, state.root.className);
    return state;
}; //# sourceMappingURL=useMenuDividerStyles.styles.js.map
